// RAPIFAST :: capa REAL de verificación documental (sin datos ficticios).
// Envuelve EXCLUSIVAMENTE las RPCs y el helper de Storage ya existentes:
//   - RPCs de 0024_pilot_verification.sql
//   - helper de Storage privado de verificationStorage.js (bucket 0025)
// Requiere las migraciones 0024 y 0025 APLICADAS en el proyecto Supabase.
// Mientras no estén aplicadas, estas llamadas devuelven el error real del
// servidor (RPC/tabla/bucket inexistente): NO se simula ninguna respuesta.
import { rpc } from "@/lib/supabase";

// Tipos EXACTOS del enum driver_doc_type (0024). No agregar valores inventados.
export const DRIVER_DOC_TYPES = ["CEDULA", "LICENCIA", "SOAT", "TARJETA_PROPIEDAD", "TECNOMECANICA"];
// Obligatorios siempre (is_driver_habilitado). TECNOMECANICA se exige solo si el
// vehículo activo NO es MOTORCYCLE (se resuelve con el tipo real del vehículo).
export const DRIVER_DOC_ALWAYS = ["CEDULA", "LICENCIA", "SOAT", "TARJETA_PROPIEDAD"];
// Documentos con fecha de vencimiento que la puerta evalúa (expires_at < hoy).
export const DRIVER_DOC_EXPIRY = ["LICENCIA", "SOAT", "TECNOMECANICA"];

export const DRIVER_DOC_LABELS = {
  CEDULA: "Documento de identidad (cédula)",
  LICENCIA: "Licencia de conducción",
  SOAT: "SOAT",
  TARJETA_PROPIEDAD: "Tarjeta de propiedad / Licencia de tránsito",
  TECNOMECANICA: "Revisión técnico-mecánica",
};

// Estados EXACTOS del enum verification_status (0024).
export const VERIF_STATUS_META = {
  PENDING: { label: "Pendiente de revisión", cls: "text-amber-400 bg-amber-500/10 border-amber-500/40" },
  VERIFIED: { label: "Verificado", cls: "text-emerald-400 bg-emerald-500/10 border-emerald-500/40" },
  REJECTED: { label: "Rechazado", cls: "text-red-400 bg-red-500/10 border-red-500/40" },
  EXPIRED: { label: "Vencido", cls: "text-red-400 bg-red-600/15 border-red-600/50" },
};

export const isExpired = (expires_at) =>
  !!expires_at && expires_at < new Date().toISOString().slice(0, 10);

// Vista del estado del documento considerando el vencimiento (solo presentación;
// la decisión real de habilitación la toma is_driver_habilitado en el servidor).
export const docDisplayStatus = (row) =>
  row && row.status === "VERIFIED" && isExpired(row.expires_at) ? "EXPIRED" : row?.status;

// ---- Conductor ----
export const getMyDriverDocuments = () => rpc("get_my_driver_documents");

export const upsertMyDriverDocument = ({ docType, storagePath, docNumber, issuedAt, expiresAt }) =>
  rpc("upsert_my_driver_document", {
    p_doc_type: docType,
    p_storage_path: storagePath,
    p_doc_number: docNumber || null,
    p_issued_at: issuedAt || null,
    p_expires_at: expiresAt || null,
  });

// ---- Administrador ----
export const adminGetPendingVerifications = () => rpc("admin_get_pending_verifications");

export const adminReviewDriverDocument = ({ documentId, status, notes }) =>
  rpc("admin_review_driver_document", { p_document_id: documentId, p_status: status, p_notes: notes || null });

export const adminReviewBusinessVerification = ({ businessId, status, notes }) =>
  rpc("admin_review_business_verification", { p_business_id: businessId, p_status: status, p_notes: notes || null });

// ---- Negocio (firma EXACTA de la RPC de 0024; NO llamar mientras 0024 no esté aplicada) ----
export const upsertMyBusinessVerification = ({ legalName, address, contactName, contactPhone, agreementVersion }) =>
  rpc("upsert_my_business_verification", {
    p_legal_name: legalName || null,
    p_nit: null, // el piloto no exige NIT
    p_address: address || null,
    p_contact_name: contactName || null,
    p_contact_phone: contactPhone || null,
    p_agreement_version: agreementVersion || null,
  });